import React, { Component } from "react";
import { connect } from "react-redux";
import { setAndFetchGreaterRegions} from "../../actions";
import { Button, ButtonGroup } from 'reactstrap';


export class CompareGreaterRegion extends Component {
  constructor(props) {
    super(props);
      this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
  
  const selectedRegion = e.target.getAttribute('data-region');
  this.props.setGreaterRegion(selectedRegion);

  }
componentDidMount()
{
  let selectedRegion = "Americas";
  if(this.props.selectedRegion !== "")
  {
    selectedRegion = this.props.selectedRegion;
  }
  this.props.setGreaterRegion(selectedRegion);
}
  render() {

    return (
      
      <div className="RegionsGroupTesting" >
        <ButtonGroup id ="RegionsButtonGroupTesting" className = "button col-3"> 
            <Button className="modal-button" id="c-Global" data-region="Global"  onClick={this.onClick}>
                Global
            </Button>
            <Button className="modal-button" id="c-Americas" data-region="Americas"  onClick={this.onClick}>
                Americas
            </Button>
            <Button className="modal-button" id="c-EMEA" data-region="Europe"  onClick={this.onClick}>
              Europe
            </Button>
            <Button className="modal-button" id="c-APAC" data-region="Asia Pacific"  onClick={this.onClick}>
            Asia Pacific
            </Button>
        </ButtonGroup>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { 
   
    marketsList: state.comparemarketslist,
    selectedRegion: state.comparegreaterregion
  };
};

const mapDispatchToProps = (dispatch)=> {

  return {
    setGreaterRegion: (greaterRegion) => {
      dispatch(setAndFetchGreaterRegions(greaterRegion));
    }

  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompareGreaterRegion);
